import React, { Component } from "react";
import {
  Row,
  Col,
  Button,
  Label,
  Input,
  FormGroup
} from "reactstrap";
import axios from 'axios';
import olWKT from "ol/format/WKT";
import httpClient from '../../services/HttpClient';


class ContentForm extends Component {

  state = {
    exportName: '',
    errorMsg: ''
  }

  readyToSubmit = () => {
    const { exportName } = this.state;;
    const { validatedFeature, exportItems, exportFormats } = this.props;

    if(!validatedFeature) {
      return false;
    }

    let exportItemsValid = false;
    //See if at least 1 item is selected
    exportItems.forEach(item=>{
      if(item.Selected) {
        exportItemsValid = true;
      }
    });


    let formatItemsValid = false;
    //See if at least 1 item is selected
    exportFormats.forEach(item=>{
      if(item.Selected) {
        formatItemsValid = true;
      }
    });

    let errorMsg = '';
    if(!exportItemsValid) {
      errorMsg += "  You must select at least one type of Data to export."
    }

    if(!formatItemsValid) {
      errorMsg += "  You must select at least one export format."
    }

    
    if(!exportName) {
      errorMsg += "  You must enter a name for this export."
    }
    
    errorMsg = errorMsg.trim();

    return errorMsg;
  };

  onExportNameChange = (e) => {
    this.setState({
      exportName: e.target.value
    })
  }


  submitRequest = () => {
    const { exportName } = this.state;;
    const { validatedFeature, setLoading, setInfoMessage, exportItems, exportFormats } = this.props;

    let validationError = this.readyToSubmit();
    if(!!validationError) {
      this.setState({errorMsg: validationError});
      return;
    } else {
      this.setState({errorMsg:''});
    }

    const apiBaseUrl = window.clipship_config.ApiBaseUrl;

    const wktFormat = new olWKT();
    const clonedFeature = validatedFeature.clone();
    const srcProj = 'EPSG:3857'
    const destProj = 'EPSG:4326'
    clonedFeature.getGeometry().transform(srcProj, destProj);
    let wkt = wktFormat.writeGeometry(clonedFeature.getGeometry());

    let selecctedExportItems = [];
    exportItems.forEach(item=>{
      if(item.Selected) {
        selecctedExportItems.push(item.item_key);
      }
    });


    let selectedFormatItems = [];
    exportFormats.forEach(item=>{
      if(item.Selected) {
        selectedFormatItems.push(item.item_key);
      }
    });

    const postData = async () => {
      const data = {
        "export_name": exportName,
        "export_options": {
          "desiredLayers": selecctedExportItems,
          "outputFormats": selectedFormatItems
        },
        "export_area_wkt": wkt,
      };
    
      try {
        const response = await httpClient.post(`${apiBaseUrl}/request`, data);
        if(response.status === 201 ) {
          setLoading(false,()=>{
            setInfoMessage(
              "Success",
              'You request has been successfuly registered.  You will receive an email with a link to download data soon.'
              ,true
            );
          });
        } else {
          setLoading(false,()=>{
            setInfoMessage("Success",'There was an error registering your request.  Please try again.');
          });
        }
      } catch (error) {
        setLoading(false,()=>{
          setInfoMessage("Success",'There was an error registering your request.  Please try again.');
        });
      }
    };

    setLoading(true,postData);
  };

  render() {
    const { errorMsg, exportName } = this.state;
    const { validatedFeature, goBack, rawFeatures, exportItems, setExportItems, exportFormats, setExportFormats } = this.props;

    if(!validatedFeature) {
      return '';
    }
    return (
      <>
        <hr />
        <Row>
          <Col md="9">
            <div className="project-row-title" style={{textAlign: 'center'}}>Setup Data Extract</div>
          </Col>
          <Col md="3">
            <Button className="rounded-pill" style={{ float: 'right', marginRight: 30}} onClick={goBack}>Back</Button>
          </Col>
        </Row>
        <hr />
        <Row style={{padding: 20, margin:30, marginTop:10}}>
          <Col md="12">
              <div className="project-row-title" style={{paddingBottom:10}}>Name</div>
              <Input
                type="text"
                name="exportname"
                id="exportname"
                placeholder="Enter a project or permit name"
                value={exportName}
                onChange={this.onExportNameChange}
                />
            </Col>
            <Col md="12" style={{marginTop: 25}}>
            <hr />
            <div className="project-row-title" style={{paddingBottom:10}}>Select Data To Export</div>
            {exportItems.map((item, i) => {
              return <FormGroup check key={item.id}>
                  <Input
                    type="checkbox"
                    checked={item.Selected}
                    onChange={e => setExportItems(item.id)}
                  />
                  {' '}
                  <Label check>
                  {item.item_label}
                  </Label>
                </FormGroup>
                
            })}
          </Col>
          <Col md="12" style={{marginTop: 25}}>
          <hr />
            <div className="project-row-title" style={{paddingBottom:10}}>Select Formats To Include</div>
            {exportFormats.map((item, i) => {
              return <FormGroup check key={item.id}>
                  <Input
                    type="checkbox"
                    checked={item.Selected}
                    onChange={e => setExportFormats(item.id)}
                  />
                  {' '}
                  <Label check>
                  {item.item_label}
                  </Label>
                </FormGroup>
                
            })}
          </Col>
        </Row>
        <Row style={{margin:50, textAlign:'center'}}>
          {!!errorMsg &&
            <Col md="12" style={{color:'red', marginBottom: 10}}>
              {errorMsg}
            </Col>
          }
          <Col md="12">
            <Button className="rounded-pill" color="primary" 
              onClick={this.submitRequest}
              style={{opacity: this.readyToSubmit()=='' ? 1 : 0.4, width:'100%'}}>Submit</Button>
          </Col>
        </Row>
      </>
    );
  }
}

export default ContentForm;